// extracted by mini-css-extract-plugin
module.exports = {"error":"not-found_error__BzqgT","content":"not-found_content__1X3RS","text":"not-found_text__7BG2Z","child":"not-found_child__4PJh0"};